@if (showNoResultsLayout) {
    <section (click)="clickInsideComponent=true" class="dropdown-section"><div class="dropdown-comment">
        <div class="dropdown-item-text">No results containing all your search terms were found.
            <div class="text-gray-30 text-small pt-4px pb-4px">
                <p class="mb-0">Your search - {{ inputText }} - did not result in any matches.</p>
                <p class="mb-0">Suggestions:</p>
                <ul class="mb-0 pl-20">
                    <li>Check your spelling.</li>
                    <li>Try different keywords.</li>
                    <li>Try more general keywords</li>
                </ul>
            </div>
        </div>
    </div></section>
}
@for (extraCategory of extraCategoryResults; track $index) {
    <section (click)="clickInsideComponent=true" class="dropdown-section">
        @if (extraLinksHeaders[extraCategory]) {
            <div class="dropdown-header"><span class="text-gray-30">{{ extraLinksHeaders[extraCategory]?.label }}</span>
                <a class="btn btn-transparent arrow-right" href="javascript:void(0)"
                (click)="toggleSection(extraCategory)"
                [style.rotate]="extraLinksHeaders[extraCategory]?.isOpen ? '0deg' : '90deg'" ycnTooltip tooltipPlacement="bottom" 
                [tooltipTitle]="extraLinksHeaders[extraCategory]?.isOpen  ? 'Close' : 'Open'"></a>
            </div>
        }
        <div class="dropdown-section-body" [style.display]="extraLinksHeaders[extraCategory] === undefined || extraLinksHeaders[extraCategory]?.isOpen ? 'block' : 'none'">
            @for (extraLink of extraLinksCategories[extraCategory]; track extraLink.label) {
                @switch (extraLink.type) {
                    @case ('security') {
                        <div class="dropdown-item" [ngClass]="{'active': (flatResults | indexOf:extraLink) === selectedIndex}"
                            (mouseenter)="setSelectedIndexOnMouseEnter(extraLink)" (click)="clickResult()">
                            <div class="dropdown-item-text">
                                <span><span class="text-bold">{{ extraLink.label }}</span>&nbsp;{{ extraLink.description }}</span>
                            </div>
                        </div>
                    }
                    @case ('asset') {
                        <a class="dropdown-item" href="javascript:void(0)"
                            (mouseenter)="setSelectedIndexOnMouseEnter(extraLink)" (click)="clickResult()"
                            [ngClass]="{'active': (flatResults | indexOf:extraLink) === selectedIndex}">
                            <div class="dropdown-item-text"> 
                                <div class="file-name">
                                    <div [class]="'file-icon file-' + extraLink.suffix">
                                        <svg ycnIcon name="icon-file"></svg>
                                        <div class="file-abbr">{{ extraLink.suffix }}</div>
                                    </div>
                                    <span class="text-default">{{ extraLink.label }}</span>
                                </div>
                            </div>
                        </a>
                    }
                    @case ('searchall') {
                        <div [ngClass]="{'active': (flatResults | indexOf:extraLink) === selectedIndex}"
                            class="dropdown-item"
                            (mouseenter)="setSelectedIndexOnMouseEnter(extraLink)" (click)="clickResult()">
                            <div class="dropdown-item-text">
                                <span>Search YCharts for "<span class="text-bold">{{ inputText }}</span>"</span>
                            </div>
                        </div>
                    }
                    @case ('ai') {
                        <a class="dropdown-item align-items-center bg-ai"
                            [ngClass]="{'active': (flatResults | indexOf:extraLink) === selectedIndex}"
                            (mouseenter)="setSelectedIndexOnMouseEnter(extraLink)" (click)="clickResult()">
                            <div class="dropdown-item-text">
                                <span>
                                    {{ getAILinkPrefix() }}
                                    <span class="text-bold">{{ extraLink.label || 'AI Agent' }}</span>
                                </span>
                            </div>
                            <div class="dropdown-item-actions">
                                <svg ycnIcon name="icon-collapse"></svg>
                            </div>
                        </a>
                    }
                     @case ('scenariosai') {
                         @if (inputText.trim() !== "") {
                            <a class="dropdown-item align-items-center bg-ai"
                                [ngClass]="{'active': (flatResults | indexOf:extraLink) === selectedIndex}"
                                (mouseenter)="setSelectedIndexOnMouseEnter(extraLink)" (click)="clickResult()">
                                <div class="dropdown-item-text">
                                    <span>

                                            {{ 'Send "' + inputText + '" to the'}}
                                            <span class="text-bold">Scenario Tool</span>

                                    </span>
                                </div>
                                <div class="dropdown-item-actions">
                                    <svg ycnIcon name="icon-collapse"></svg>
                                </div>
                            </a>
                         }
                    }
                }
            }
        </div>
    </section>
}